import React from 'react'
import { connect } from 'react-redux';
import { Button, Select, Input, Tag, Typography } from 'antd';
import { localization } from '../../../../Utils/Localization/localization';
import classes from './AddProductPage.module.scss';
import { ICategory } from '../../../../Utils/types';
import { userLevelSelector } from '../../../../Redux/Reducers/userReducer';

interface StateProps {
  level: number
}
interface DispatchProps { }
interface Props extends StateProps, DispatchProps {
  language: string,
  tags: string[],
  name: string,
  price: number,
  quantity: number,
  category: number,
  categories: ICategory[],
  newProductValues: (name: string, value: any) => void,
  nextStage: () => void
}

function ProductDescription(props: Props) {
  const [tag, setTag] = React.useState('');
  const permissionLevel = props.level >= 2;

  return (
    <div className={classes.AddProductPage}>
      {
        !permissionLevel
        && <Typography.Title
          mark
          disabled
        >
          {localization('noPermission', props.language)}
        </Typography.Title>
      }
      <h2>{localization('newProduct', props.language)}</h2>
      <div className={classes.Price}>
        <span className={classes.Span}>
          {`${localization('name', props.language)}: ${props.name}`}
        </span>
        <Input
          value={props.name}
          onChange={(e: any) => {
            permissionLevel && props.newProductValues('name', e.target.value)
          }}
        />
      </div>
      <div className={classes.Tags}>
        <span className={classes.Span}>{localization('tags', props.language)}</span>
        <div>
          {
            props.tags.map((item, index) => {
              return (
                <Tag
                  closable
                  key={item}
                  onClose={() => {
                    let array = [...props.tags];
                    array.splice(index, 1);
                    props.newProductValues('tags', array);
                  }}
                >
                  {item}
                </Tag>);
            })
          }
        </div>
        <Input
          placeholder={localization('newTag', props.language)}
          value={tag}
          onChange={(e: any) => permissionLevel && setTag(e.target.value)}
          onPressEnter={() => {
            if (tag !== '') {
              const newTagsArray: string[] = [...props.tags];
              newTagsArray.push(tag);
              props.newProductValues('tags', newTagsArray);
              setTag('');
            }
          }}
        />
      </div>
      <div className={classes.Price}>
        <span className={classes.Span}>
          {`${localization('price', props.language)} ${props.price === 0 ? '---' : props.price} ₽`}
        </span>
        <Input
          value={props.price === 0 ? '' : props.price}
          onChange={(e: any) => {
            permissionLevel && props.newProductValues('price', e.target.value)
          }}
        />
      </div>
      <div>
        <span className={classes.Span}>
          {`${localization('quantity', props.language)} ${props.quantity}`}
        </span>
        <Input
          value={props.quantity}
          onChange={(e: any) => {
            permissionLevel && props.newProductValues('quantity', e.target.value)
          }}
        />
      </div>
      <span className={classes.Span}>{localization('category', props.language)}</span>
      <Select
        style={{ width: '200px', marginBottom: '20px' }}
        value={props.category}
        onChange={(e: any) => {
          permissionLevel && props.newProductValues('categoryId', e);
        }}
      >
        {
          props.categories.map((item) => {
            return (
              <Select.Option
                value={item.id}
                key={item.id}
              >
                {item.name}
              </Select.Option>
            );
          })
        }
      </Select>
      <Button
        type={'primary'}
        onClick={props.nextStage}
        disabled={
          !props.tags
          || !props.price
          || !props.name
          || !props.quantity
          || !props.category
          || !permissionLevel
        }
      >
        {localization('next', props.language)}
      </Button>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    level: userLevelSelector(state)
  }
}
const mapDispatchToProps = {}

const ConnectedProductDescription = connect(mapStateToProps, mapDispatchToProps)(ProductDescription);
export { ConnectedProductDescription as ProductDescription };